import * as React from 'react';

import '@app/scss/valueInclusive/index.scss';

interface PageSectionProps {
	id?: string;
	header?: React.ReactNode;
	alignHeader?: React.CSSProperties['textAlign'];
	footer?: React.ReactNode;
}

type OwnProps = React.PropsWithChildren<PageSectionProps>;

export const PageSection: React.FC<OwnProps> = (props: OwnProps) => (
	<div className="page-section" id={props.id}>
		<div className="page-section__container">
			{
				props.header
					? (
						<h1
							className="text-size_hard-large"
							style={{ textAlign: props.alignHeader, width: '100%' }}
						>
							{props.header}
						</h1>
					) : null
			}
			{props.children}
		</div>
		{props.footer}
	</div>
);
